var map = {
	"./qrcode_btc.png": 446,
	"./qrcode_ht.png": 447
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 445;


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift ^\.\/qrcode_.*\.png$
// module id = 445
// module chunks = 0